<template>
	<v-dialog v-model="showDialog" max-width="900" overlay-opacity="0.9">
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">{{ matter.name }} 製品一覧</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="showDialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<v-sheet elevation="0" class="pa-4">
				<div
					class="table-container mt-6"
					v-if="matter.ordered_products && matter.ordered_products.length > 0"
				>
					<div class="d-flex mb-2">
						<div class="mr-3">※部品表が登録されている製品のみ選択できます。</div>
						<div>
							<a @click="$router.push({ name: 'ordered_parts_list' })" text>部品表ページはこちら</a>
						</div>
					</div>
					<v-data-table
						locale="ja-JP"
						:headers="orderedProductsHeaders"
						:items="matter.ordered_products"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr
								@click="
									item.order_components &&
										item.order_components.length > 0 &&
										selectProduct(item.id)
								"
							>
								<td
									class="pointer"
									:class="{
										'grey-out': item.order_components.length === 0,
									}"
								>
									{{ item.product_number }}
								</td>
								<td
									class="pointer"
									v-if="item.product"
									:class="{
										'grey-out': item.order_components.length === 0,
									}"
								>
									{{ item.product.name }}
								</td>
								<td
									class="pointer"
									:class="{
										'grey-out': item.order_components.length === 0,
									}"
								>
									{{ item.sub_name }}
								</td>
								<td
									class="pointer"
									:class="{
										'grey-out': item.order_components.length === 0,
									}"
								>
									{{ item.quantity }}
								</td>
							</tr>
						</template>
					</v-data-table>
					<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
				</div>
				<div v-else class="table-container mt-6">
					<div class="d-flex mb-2">
						<div class="mr-3">※部品表が登録されている製品のみ選択できます。</div>
						<a @click="$router.push({ name: 'ordered_parts_list' })" text>部品表ページはこちら</a>
					</div>
					<v-data-table
						locale="ja-JP"
						:headers="matterProductsHeaders"
						:items="matter.matter_products"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
					>
						<template v-slot:item="{ item }">
							<tr
								@click="
									item.order_components &&
										item.order_components.length > 0 &&
										selectMatterProduct(item.id)
								"
							>
								<td
									class="pointer"
									v-if="item.product"
									:class="{
										'grey-out': item.order_components.length == 0,
									}"
								>
									{{ item.product.name }}
								</td>
								<td
									class="pointer"
									:class="{
										'grey-out': item.order_components.length == 0,
									}"
								>
									{{ item.sub_name }}
								</td>
								<td
									class="pointer"
									:class="{
										'grey-out': item.order_components.length == 0,
									}"
								>
									{{ item.quantity }}
								</td>
							</tr>
						</template>
					</v-data-table>
					<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
				</div>
			</v-sheet>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import PaginationModule from "../../../modules/PaginationModule.vue"

export default {
	props: {
		dialog: {
			type: Boolean,
			required: false,
			default: false,
		},
		matter: {
			type: Object,
			required: true,
		},
	},
	components: {
		PaginationModule,
	},
	data() {
		return {
			searchMatterName: "",
			searchProductNumber: "",
			order_components: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			orderedProductsHeaders: [
				{ text: "製造番号", value: "product_number", width: "200px", divider: true },
				{ text: "製品名", value: "name", width: "200px", divider: true },
				{ text: "サブネーム", value: "sub_name", width: "200px", divider: true },
				{ text: "数量", value: "quantity", width: "200px", divider: true },
			],
			matterProductsHeaders: [
				{ text: "製品名", value: "name", width: "200px", divider: true },
				{ text: "サブネーム", value: "sub_name", width: "200px", divider: true },
				{ text: "数量", value: "quantity", width: "200px", divider: true },
			],
			openDataTable: false,
			productNumberFlag: false,
			matterFlag: false,
			matters: [],
		}
	},

	methods: {
		getPage(page) {
			if (this.productNumberFlag) {
				this.searchOrderedComponent(page)
			}
			if (this.matterFlag) {
				this.searchMatters(page)
			}
		},

		searchOrderedComponent(page) {
			const headers = authenticate.setHeader()
			const params = {
				ordered_product_product_number_cont: this.searchProductNumber,
			}
			axios
				.get(`/erp/v1/order_data/search_order_components`, {
					headers,
					params: { q: params, page },
				})
				.then((res) => {
					this.order_components = res.data.order_components
					this.openDataTable = true
					this.pagination = res.data.pagination
					this.productNumberFlag = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		searchMatters(page) {
			const headers = authenticate.setHeader()
			const params = {
				name_cont: this.searchMatterName,
			}
			axios
				.get(`/erp/v1/order_data/search_matters`, {
					headers,
					params: { q: params, page },
				})
				.then((res) => {
					this.matters = res.data.matters
					this.openDataTable = true
					this.pagination = res.data.pagination
					this.matterFlag = true
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		selectProduct(productId) {
			const displayBtn = true
			this.$emit("selectProduct", productId, displayBtn)
			this.showDialog = false
		},
		selectMatterProduct(matterProductId) {
			const displayBtn = true
			this.$emit("selectMatterProduct", matterProductId, displayBtn)
			this.showDialog = false
		},
		selectMatter(matter) {
			this.matter = matter
			this.$refs.products.openDialog()
		},
		closeMattersDialog() {
			this.searchMatterName = ""
			this.matterFlag = false
		},
		closeProductDialog() {
			this.searchProductNumber = ""
			this.productNumberFlag = false
		},
	},

	computed: {
		showDialog: {
			get() {
				return this.dialog
			},
			set(newVal) {
				return this.$emit("update:dialog", newVal)
			},
		},
	},
}
</script>

<style scoped lang="scss">
.grey-out {
	color: rgba(0, 0, 0, 0.2);
}
.pointer {
	cursor: pointer;
}
.pointer.grey-out {
	cursor: text;
	background: white;
}
</style>
